export const slides = [
  {
    title: "Krok 1",
    subtitle: "Włącz skaner",
    text:
      "Włącz skaner w aplikacji. Wybierz ikonę 'Skanuj' aby uruchomiść skaner.",
  },
  {
    title: "Krok 2",
    subtitle: "Zeskanuj kod QR",
    text:
      "Jeżeli kupujesz na miejscu, personel pokaże Ci niebieską kartę z kodem QR, natomiast jeżeli zamawiasz online to do Twojego zamówienia dołączona będzie niebieska karta StampCardGo z kodem QR. Zeskanuj kod QR z karty udostępnionej przez personel lub dołączonej do zamówienia.",
  },
  {
    title: "Krok 3",
    subtitle: "Pieczątka została dodana",
    text:
      "Po zeskanowaniu kodu QR na ekranie pojawi się komunikat 'Pieczątka została dodana'. Pieczątka została dodana do Twojej karty lojalnościowej w aplikacji.",
  },
];
